export default __webpack_public_path__ + "static/media/heroLeftDivBg.a6f5ab02.png";